
const REMOTE_API = './data_handler.php';

export interface SessionLog {
    id: string;
    name: string;
    email: string;
    startTime: number;
    endTime?: number;
    durationMinutes?: number;
    ip?: string;
}

const STORAGE_KEY = 'gea_ndt_session_logs';

export const logSessionStart = (name: string, email: string, ip?: string) => {
    try {
        const logs: SessionLog[] = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        const newLog: SessionLog = {
            id: crypto.randomUUID(),
            name,
            email,
            startTime: Date.now(),
            ip
        };
        logs.unshift(newLog);
        // Keep last 100 logs
        // Local Storage Sync (Backup)
        localStorage.setItem(STORAGE_KEY, JSON.stringify(logs.slice(0, 100)));
        sessionStorage.setItem('current_log_id', newLog.id);
        if (ip) sessionStorage.setItem('nd_inspector_ip', ip);

        // Remote Synology Sync
        fetch(REMOTE_API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ type: 'session', data: newLog })
        }).catch(err => console.warn("Remote log failed:", err));

    } catch (e) {
        console.error("Failed to log session start:", e);
    }
};

export const logSessionEnd = () => {
    try {
        const currentId = sessionStorage.getItem('current_log_id');
        if (!currentId) return;

        const logs: SessionLog[] = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        const logIndex = logs.findIndex(l => l.id === currentId);

        if (logIndex !== -1) {
            const endTime = Date.now();
            const durationMs = endTime - logs[logIndex].startTime;
            logs[logIndex].endTime = endTime;
            logs[logIndex].durationMinutes = Math.round(durationMs / 60000);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
            sessionStorage.removeItem('current_log_id');

            // Remote Synology Sync (Update)
            fetch(REMOTE_API, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ type: 'session', data: logs[logIndex] })
            }).catch(err => console.warn("Remote log update failed:", err));
        }
    } catch (e) {
        console.error("Failed to log session end:", e);
    }
};

export const getSessionLogs = (): SessionLog[] => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
        console.error("Failed to get session logs:", e);
        return [];
    }
};

export const formatLogsAsText = (logs: SessionLog[]): string => {
    let text = "GEA-NDT ACCESS LOGS\n";
    text += "========================================\n\n";

    logs.forEach(log => {
        const start = new Date(log.startTime).toLocaleString();
        const end = log.endTime ? new Date(log.endTime).toLocaleString() : "Still Active / Connection Lost";
        const duration = log.durationMinutes !== undefined ? `${log.durationMinutes} min` : "N/A";

        text += `INSPECTOR: ${log.name}\n`;
        text += `EMAIL: ${log.email}\n`;
        text += `IP ADDRESS: ${log.ip || "Unknown"}\n`;
        text += `START: ${start}\n`;
        text += `END: ${end}\n`;
        text += `DURATION: ${duration}\n`;
        text += `----------------------------------------\n`;
    });

    return text;
};

export const clearLogs = () => {
    localStorage.removeItem(STORAGE_KEY);
};

export const getRemoteData = async () => {
    try {
        const response = await fetch(REMOTE_API);
        return await response.json();
    } catch (e) {
        console.error("Failed to fetch remote data:", e);
        return null;
    }
};
